<div nz-row nzJustify="center">
  <span class="container" nz-col nzSpan="14">
    <img class="intro-img" src="/assets/emmet_pointing.jpg" alt="Emmet figure pointing upwards" />
    <div class="text-container">
      <div class="text">
        <h1 nz-title>Welcome to EMMET</h1>
        <p nz-text>
          Start by searching for a design using either a Design ID (10003001) or a Communication ID
          (3001).
        </p>
      </div>
    </div>
  </span>
</div>
